import request from '@/router/axios'

const base = '/api/produce/inventory-health'
const ENABLE_MOCK = process.env.VUE_APP_INVENTORY_HEALTH_USE_MOCK === 'true'

const COAL_TYPES = ['动力煤', '焦煤', '无烟煤', '褐煤', '配煤']

const MODEL_CONFIG = {
  ageWeight: 0.45,
  turnoverWeight: 0.35,
  stabilityWeight: 0.2
}

function normalize(params = {}) {
  return {
    startTime: params.startTime || '',
    endTime: params.endTime || '',
    coalType: params.coalType || ''
  }
}

function mockResolve(data) {
  return Promise.resolve({ data: { code: 200, msg: 'success', data } })
}

function scoreToLevel(score) {
  if (score >= 80) return 'green'
  if (score >= 60) return 'yellow'
  return 'red'
}

function levelLabel(level) {
  if (level === 'green') return '健康'
  if (level === 'yellow') return '预警'
  return '风险'
}

function buildMockRows(params = {}) {
  const p = normalize(params)
  const rows = COAL_TYPES.map((cargoName, idx) => {
    const custName = `演示货主${idx + 1}`
    const ageDays = 7 + idx * 8
    const turnover = Number((4.8 - idx * 0.75).toFixed(2))
    const stability = Number((92 - idx * 9).toFixed(2))
    const ageScore = Math.max(0, Number((100 - ageDays * 2.1).toFixed(2)))
    const turnoverScore = Math.max(0, Number((turnover / 5 * 100).toFixed(2)))
    const stabilityScore = Math.max(0, stability)
    const totalScore = Number(
      (
        ageScore * MODEL_CONFIG.ageWeight +
        turnoverScore * MODEL_CONFIG.turnoverWeight +
        stabilityScore * MODEL_CONFIG.stabilityWeight
      ).toFixed(2)
    )
    const level = scoreToLevel(totalScore)
    return {
      custNo: `mock-c-${idx + 1}`,
      custName,
      cargoNo: `mock-v-${idx + 1}`,
      cargoName,
      coalType: `${custName}/${cargoName}`,
      avgInventory: Number((1200 + idx * 150).toFixed(2)),
      inWeight: Number((300 + idx * 20).toFixed(2)),
      outWeight: Number((260 + idx * 15).toFixed(2)),
      ageDays,
      turnoverRate: turnover,
      stability,
      ageScore,
      turnoverScore,
      stabilityScore,
      totalScore,
      level,
      levelLabel: levelLabel(level)
    }
  })
  return rows.filter((r) => (p.coalType ? r.cargoName === p.coalType : true))
}

export const fetchModelConfig = () => {
  if (!ENABLE_MOCK) {
    return request({ url: `${base}/modelConfig`, method: 'post', data: {} })
  }
  return mockResolve(MODEL_CONFIG)
}

export const fetchHealthOverview = (params) => {
  if (!ENABLE_MOCK) {
    return request({ url: `${base}/overview`, method: 'post', data: params })
  }
  const rows = buildMockRows(params)
  const avgScore = rows.length
    ? Number((rows.reduce((sum, row) => sum + row.totalScore, 0) / rows.length).toFixed(2))
    : 0
  const levelMap = { green: 0, yellow: 0, red: 0 }
  rows.forEach((item) => {
    levelMap[item.level] += 1
  })
  return mockResolve({
    avgScore,
    greenCount: levelMap.green,
    yellowCount: levelMap.yellow,
    redCount: levelMap.red,
    coalTypeCount: rows.length,
    scoreChange: 0,
    focusChange: 0,
    turnoverChange: 0
  })
}

export const fetchHealthDetailPage = (params) => {
  if (!ENABLE_MOCK) {
    return request({ url: `${base}/detailPage`, method: 'post', data: params })
  }
  const page = Number(params.page || 1)
  const size = Number(params.size || 10)
  const rows = buildMockRows(params).sort((a, b) => a.totalScore - b.totalScore)
  const start = (page - 1) * size
  const end = start + size
  return mockResolve({
    records: rows.slice(start, end),
    total: rows.length,
    page,
    size
  })
}

export const fetchImproveSuggestions = (params) => {
  if (!ENABLE_MOCK) {
    return request({ url: `${base}/suggestions`, method: 'post', data: params })
  }
  const rows = buildMockRows(params).sort((a, b) => a.totalScore - b.totalScore)
  const suggestions = rows.slice(0, 3).map((item, idx) => ({
    id: idx + 1,
    title: `关注${item.coalType}库存健康`,
    priority: item.level === 'red' ? '高' : '中',
    content: `${item.coalType}当前健康分为${item.totalScore}，建议优先结合发运计划消化低周转库存。`
  }))
  return mockResolve({ suggestions })
}

export const fetchCoalTypeOptions = (params = {}) => {
  if (!ENABLE_MOCK) {
    return request({ url: `${base}/coalTypeOptions`, method: 'post', data: params })
  }
  return mockResolve({
    coalTypes: COAL_TYPES.map((cargoName, index) => ({
      cargoNo: `mock-v-${index + 1}`,
      cargoName
    }))
  })
}
